import { ReactNode } from 'react';

import { EnvironmentBadge } from '../../../common/components/environment/EnvironmentBadge';

interface AuthLayoutProps {
  leftPanel: ReactNode;
  rightPanel: ReactNode;
}

/**
 * The signed-out shell: the form on the left half, the artwork bleeding to the
 * edges of the right half.
 *
 * Fixed and full-viewport rather than laid out in the page, because there is no
 * app chrome yet — nothing behind it should ever scroll into view. The form
 * half scrolls on its own so a short window never clips the button.
 */
export const AuthLayout = ({ leftPanel, rightPanel }: AuthLayoutProps) => {
  return (
    <div className="fixed inset-0 z-[9999] grid size-full overflow-hidden bg-background antialiased md:grid-cols-2">
      {/* Which backoffice this is, before signing in: nothing on production. */}
      <EnvironmentBadge className="absolute start-4 top-4 z-10 sm:start-6 sm:top-6" />
      <div className="flex h-full min-h-0 animate-in flex-col overflow-y-auto px-6 py-6 fade-in duration-700 sm:px-10">
        {leftPanel}
      </div>

      {/* The artwork is decoration; below md it costs more room than it earns. */}
      <div className="relative hidden h-full min-h-0 animate-in overflow-hidden fade-in duration-1000 md:block">
        {rightPanel}
      </div>
    </div>
  );
};
